<template>
  <footer class="hidden desktop:flex items-center justify-center gap-3 px-6 py-6 bg-bg">
    <p class="footer-text">{{ t('shell.footer.copyright') }}</p>
    <span class="footer-sep">·</span>
    <NuxtLink
      to="/help"
      class="footer-link"
      >{{ t('shell.footer.helpCenter') }}</NuxtLink
    >
    <span class="footer-sep">·</span>
    <NuxtLink
      to="/terms"
      class="footer-link"
      >{{ t('shell.legal.termsOfUse') }}</NuxtLink
    >
    <span class="footer-sep">·</span>
    <NuxtLink
      to="/privacy"
      class="footer-link"
      >{{ t('shell.legal.privacyNotice') }}</NuxtLink
    >
    <span class="footer-sep">·</span>
    <NuxtLink
      to="/delete-account"
      class="footer-link"
      >{{ t('shell.legal.deleteAccount') }}</NuxtLink
    >
    <LocaleMenu placement="top" />
  </footer>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.footer-text {
  font-family: 'Satoshi', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0%;
  color: #b6b7b9;
  text-align: center;
}

.footer-sep {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #d4d5d7;
}

.footer-link {
  font-family: 'Satoshi', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  color: #b6b7b9;
  transition: color 0.15s ease;

  &:hover {
    color: #8a8b8d;
  }
}
</style>
